import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import { subscribeToNotificationTaps } from '../lib/pushNotifications';
import { pushTapTarget } from '../lib/pushTapRoute';

// Opens the screen a tapped push is about (v1.0.2 §6c). Listens only while signed in: iOS keeps
// a tap until a listener attaches, so a tap that launched the app at sign-in routes afterwards.
export default function PushTapRouter() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    return subscribeToNotificationTaps((data) => {
      const { path, notificationId } = pushTapTarget(data);
      if (notificationId) api.patch(`/notifications/${notificationId}/read`).catch(() => {});
      if (path) navigate(path);
    });
  }, [isAuthenticated, navigate]);

  return null;
}
